import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Label } from "../components/ui/label"

export function LabelRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()
  const text = element.text ? String(resolveSymbol(element.text) ?? "") : undefined
  return (
    <Label className={element.className} htmlFor={element.name} data-testid={`label-${element.id}`}>
      {text}
    </Label>
  )
}
